export enum NotificationType {
    Error = 'error',
    Success = 'success',
    Warning = 'warning',
    Info = 'info',
    InfoStepper = 'InfoStepper'
  }